import { buildHeaders, getApiBaseUrl } from "@/utils/getApiBaseUrl";


export const userProfileService = {

  setUserProfile: async (token: string) => {
    try {

      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/subscriber/set-user-profile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
            ...buildHeaders(token, 'setUserProfile', ''),
          },
          body: JSON.stringify({}),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }

      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(
        "setUserProfile fetching Subscriber data:",
        error
      );
      return null;
    }
  },
  getUserProfile: async (token: string) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/subscriber/get-user-profile`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
            ...buildHeaders(token,'getUserProfile',''),
          },
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("getUserProfile Error fetching Subscriber data:", error);
      return null;
    }
  },
};
